import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PaymentLayout from './layout/PaymentLayout';
import PaymentSecurity from './PaymentSecurity';
import { siteLinks } from './layout/Header';

const results = {
  success: {
    hero: 'Comprobante de pago', label: 'Pago aprobado', title: 'Tu pago se realizó con éxito',
    description: 'Recibimos tu pago. Gracias por confiar en Tusmultas.cl.',
    action: 'Volver al sitio principal',
  },
  failed: {
    hero: 'Resultado del pago', label: 'Pago rechazado', title: 'No pudimos procesar tu pago',
    description: 'La transacción fue rechazada. Revisa los datos de tu tarjeta o intenta con otro medio de pago.',
    action: 'Intentar nuevamente',
  },
  aborted: {
    hero: 'Resultado del pago', label: 'Pago cancelado', title: 'Cancelaste tu pago',
    description: 'El proceso de pago fue cancelado antes de completarse. Puedes volver a intentarlo cuando quieras.',
    action: 'Volver a pagar',
  },
};

export default function PaymentResult({ status }) {
  const { state } = useLocation();
  const result = results[status];
  const data = state || {};
  const approved = status === 'success';
  const rawAmount = typeof data.amount === 'string' ? data.amount.replace(/\./g, '') : data.amount;
  const hasAmount = rawAmount !== null && rawAmount !== undefined && rawAmount !== '' && Number.isFinite(Number(rawAmount));
  return (
    <PaymentLayout title={result.hero} subtitle="Tu tranquilidad, en cada paso">
      <section className={`payment-card result-card result-card--${status}`} aria-labelledby="result-title">
        <div className="result-icon" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            {approved ? <path d="m12 24 8 8 16-17" /> : status === 'failed' ? <><path d="m16 16 16 16m0-16L16 32" /></> : <><path d="M24 12v15" /><circle cx="24" cy="35" r="1" /></>}
          </svg>
        </div>
        <p className="eyebrow">{result.label}</p>
        <h2 id="result-title">{result.title}</h2>
        <p className="result-description">{data.name ? `${data.name}, ` : ''}{result.description}</p>
        {approved && (hasAmount || data.email) && (
          <dl className="payment-receipt">
            {hasAmount && <div><dt>Monto pagado</dt><dd>{new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(Number(rawAmount))}</dd></div>}
            {data.email && <div><dt>Correo electrónico</dt><dd>{data.email}</dd></div>}
          </dl>
        )}
        {approved && data.email && <p className="result-note">Enviaremos la información de tu pago a este correo electrónico.</p>}
        <div className="result-actions">
          {approved ? <a className="button" href={siteLinks.home}>{result.action}</a> : <Link className="button" to="/">{result.action}</Link>}
          {approved ? <Link className="text-link" to="/">Realizar otro pago</Link> : <a className="text-link" href="mailto:libera@tusmultas.cl">¿Necesitas ayuda? Contáctanos</a>}
        </div>
        <PaymentSecurity />
      </section>
    </PaymentLayout>
  );
}